import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealMarketMedianAgeField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='market-median-age-helper-text'
          label='Median Age'
          id='market_median_age'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
        />

        {error ? (
          <FormHelperText id='market-median-age-helper-text'>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='market-median-age-helper-text'>
            Enter the market's median population age.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
